import { useI18n } from "@wojo/localization";
import { Markdown, Text } from "@wojo/ui";
import React, { useId } from "react";
import { LuActivity } from "react-icons/lu";
import styles from "./Itinerary.module.scss";

type ItineraryPhysicalActivityProps = {
    physicalActivity?: string | null;
};

export const ItineraryPhysicalActivity: React.FC<
    ItineraryPhysicalActivityProps
> = ({ physicalActivity }) => {
    const titleId = useId();
    const { productPage } = useI18n("productPage");

    if (!physicalActivity) {
        return null;
    }

    return (
        <section
            aria-labelledby={titleId}
            style={{ marginTop: "var(--g-spacing-lg)" }}
        >
            <Text.Detail
                id={titleId}
                variant="2"
                style={{
                    display: "flex",
                    gap: "var(--g-spacing-sm)",
                    marginBottom: "var(--g-spacing-sm)",
                    alignItems: "center",
                }}
            >
                <LuActivity aria-hidden size={20} />
                {productPage.itinerary.day.physicalActivity.heading.l()}
            </Text.Detail>
            <Markdown
                markdown={physicalActivity}
                className={styles["physical-activity-markdown"]}
            />
        </section>
    );
};
